import React from 'react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const MOSS   = '#3B6B44';
const OCHRE  = '#A6752A';
const STONE  = '#8C8275';
const FONT_DISPLAY = "'Fraunces', Georgia, serif";
const FONT_SANS    = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function BacklogCounts({ counts = {} }) {
  const items = [
    { status: 'sold',                 label: 'Sold',                 count: counts.sold || 0,                 color: OCHRE },
    { status: 'awaiting_production',  label: 'Awaiting Production',  count: counts.awaiting_production || 0,  color: STONE },
    { status: 'in_production',        label: 'In Production',        count: counts.in_production || 0,        color: OCHRE },
    { status: 'ready_for_install',    label: 'Ready for Install',    count: counts.ready_for_install || 0,    color: MOSS },
    { status: 'ready_for_pickup',     label: 'Ready for Pickup',     count: counts.ready_for_pickup || 0,     color: MOSS },
  ];

  const total = items.reduce((sum, item) => sum + item.count, 0);

  return (
    <div style={{ fontFamily: FONT_SANS }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '16px'
      }}>
        Production Pipeline
      </h3>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
        marginBottom: '16px'
      }}>
        {items.map(item => (
          <div
            key={item.status}
            style={{
              padding: '16px',
              background: `${item.color}12`,
              borderRadius: '10px',
              border: `1px solid ${item.color}30`
            }}
          >
            <div style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              fontSize: '11px',
              fontWeight: '600',
              color: item.color,
              marginBottom: '6px',
            }}>
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: item.color, flexShrink: 0 }} />
              {item.label}
            </div>
            <div style={{
              fontFamily: FONT_DISPLAY,
              fontSize: '26px',
              fontWeight: 600,
              color: item.color
            }}>
              {item.count}
            </div>
          </div>
        ))}
      </div>

      {/* Total */}
      <div style={{
        padding: '12px 16px',
        background: 'rgba(139,69,19,0.06)',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: INK
        }}>
          Total Backlog
        </span>
        <span style={{
          fontFamily: FONT_DISPLAY,
          fontSize: '19px',
          fontWeight: 600,
          color: WALNUT
        }}>
          {total}
        </span>
      </div>
    </div>
  );
}
